import { createSlice } from "@reduxjs/toolkit";
const locationDataSlice = createSlice({
    name: 'locationData',
    initialState: {
        state: [],
        districts: [],
        talukas: []
    },
    reducers: {
        setLocationData: (state, action) => {
            state.state = action.payload.state;
            state.districts = action.payload.districts;
            state.talukas = action.payload.talukas;
        }
    }
});
export const addLocationData = locationDataSlice.actions.setLocationData;
export default locationDataSlice.reducer;
